import React from 'react';

// WA-DEPARTMENT-CONTEXT-SPLIT-aug25: small colored chip that labels a WhatsApp
// thread's department (ventas vs postventa). Same number can have two distinct
// conversations, so every thread row/header carries this tag to disambiguate.
//
// Colors: ventas = emerald (matches the WhatsApp accent), postventa = indigo.
// Unknown/empty department renders nothing (legacy threads default to ventas
// upstream, so an empty value here means "don't show a tag").
const STYLES = {
  ventas:
    'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300',
  postventa:
    'bg-indigo-100 text-indigo-700 dark:bg-indigo-500/20 dark:text-indigo-300',
};

function DeptTag({ department, t, className = '' }) {
  const dept = (department || '').trim().toLowerCase();
  if (dept !== 'ventas' && dept !== 'postventa') return null;
  const label = t ? t(`whatsapp.dept.${dept}`) : dept;
  return (
    <span
      data-testid={`wa-dept-tag-${dept}`}
      className={`inline-flex flex-shrink-0 items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
        STYLES[dept] || ''
      } ${className}`}
    >
      {label}
    </span>
  );
}

export default DeptTag;
